import React from 'react';
import { Table, Select } from 'antd';
import { TriangleAlert, PackageCheck } from 'lucide-react';
import dayjs from 'dayjs';
import { StatusTag, EmptyState, CollapsibleCard } from '../../../common';
import { useMissingProducts } from './missingProducts.controller';

export default function MissingProducts({ storeChecks, setStoreChecks }) {
    const { products, filteredChecks, selected, onChange, missingCount } = useMissingProducts(storeChecks, setStoreChecks);

    const MissingProdsColumns = [
        {
            title: 'Piso de Venta',
            dataIndex: 'storeName',
            key: 'storeName',
            render: (text) => <span className="text-sm font-medium text-surface-900">{text}</span>
        },
        {
            title: 'Auditor',
            dataIndex: 'userName',
            key: 'userName',
            render: (text) => <span className="text-sm text-surface-600">{text}</span>
        },
        {
            title: 'Fecha',
            dataIndex: 'createdAt',
            key: 'createdAt',
            render: (text) => <span className="text-sm text-surface-600 tabular-nums">{dayjs(text).format('DD/MM/YYYY')}</span>
        },
        {
            title: 'Tiempo',
            dataIndex: 'totalTime',
            key: 'totalTime',
            align: 'right',
            render: (text) => <span className="text-sm text-surface-600 tabular-nums">{text} min</span>
        }
    ];

    return (
        <CollapsibleCard flush
            icon={<TriangleAlert />}
            iconTone={missingCount > 0 ? 'danger' : 'success'}
            title="Faltante en Anaquel"
            count={missingCount > 0 ? `${missingCount} productos` : undefined}
            countTone="danger">
            {products.length > 0 ? (
                <>
                    <div className="flex flex-col gap-3 px-5 pt-4 sm:flex-row sm:items-end sm:justify-between">
                        <label className="flex w-full flex-col gap-1 sm:w-80">
                            <span className="text-xs font-medium text-surface-500">Selecciona un producto para ver detalles</span>
                            <Select value={selected} onChange={(e) => onChange(e)} options={products} showSearch optionFilterProp="label" />
                        </label>
                        {selected && (
                            <div className="flex items-center gap-2 rounded-lg border border-danger-border bg-danger-bg px-3 py-2">
                                <TriangleAlert className="shrink-0 text-danger-fg" />
                                <span className="truncate text-sm font-medium text-danger-fg">{selected}</span>
                                <StatusTag tone="danger" className="ml-2 bg-white">
                                    {filteredChecks.length} pisos afectados
                                </StatusTag>
                            </div>
                        )}
                    </div>

                    <Table
                        className="mt-4"
                        dataSource={filteredChecks}
                        columns={MissingProdsColumns}
                        size="middle"
                        scroll={{ x: 560 }}
                        pagination={{
                            pageSize: 10,
                            showTotal: (total) => (
                                <span className="text-surface-500">
                                    Total <strong className="tabular-nums">{total}</strong> registros
                                </span>
                            )
                        }}
                    />
                </>
            ) : (
                <EmptyState icon={<PackageCheck />} title="Sin productos faltantes" description="No se detectaron quiebres de stock en el período" />
            )}
        </CollapsibleCard>
    );
}
